import { Injectable } from '@angular/core';

@Injectable()

export class ConfigService {
  // serverIp = 'http://localhost:1337';
  serverIp = 'https://api-procargoexpress.logisticscargo.net';
  constructor() { }
}
